/** Igual que `ONBOARDING_V2_RELEASE_TIMESTAMP` en la app principal (onboarding V2 full-screen). */
export const ONBOARDING_V2_RELEASE_ISO = '2026-04-01T00:00:00.000Z';

export function profileEligibleForWelcomeV2(createdAt: string | null | undefined): boolean {
    if (!createdAt) return false;
    return new Date(createdAt).getTime() >= new Date(ONBOARDING_V2_RELEASE_ISO).getTime();
}
